import { render, staticRenderFns } from "./RelacaoGuiasDlg.vue?vue&type=template&id=13488a37"
import script from "./RelacaoGuiasDlg.vue?vue&type=script&lang=js"
export * from "./RelacaoGuiasDlg.vue?vue&type=script&lang=js"
import style0 from "./RelacaoGuiasDlg.vue?vue&type=style&index=0&id=13488a37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports